var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusOffline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 1,
  y: 1,
  fill: "currentcolor",
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--typography--secondary)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m7.5 4.5-3 3M4.5 4.5l3 3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 4.5,
  stroke: "var(--typography--secondary)"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  stroke: "currentcolor",
  rx: 5.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 1,
  y: 1,
  fill: "currentcolor",
  rx: 5
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusOffline);
export default ForwardRef;